import { TermsOfUse } from '../../models/api-client';
import { TermsOfUseVm } from './viewModel';

const createTermsOfUseVm = (): TermsOfUseVm => ({
  singlePage: undefined,
  prepaidSupportHours: '',
  spentSupportHours: '',
  text: undefined,
});

const mapTermsOfUseToTermsOfUseVm = (termsOfUse: TermsOfUse): TermsOfUseVm => ({
  singlePage: termsOfUse.singlePage,
  prepaidSupportHours: termsOfUse.prepaidSupportHours.toLocaleString('de-DE'),
  spentSupportHours: termsOfUse.spentSupportHours.toLocaleString('de-DE'),
  text: termsOfUse.text,
});


const mapTermsOfUseVmToTermsOfUse = (termsOfUse: TermsOfUseVm): TermsOfUse => ({
  singlePage: termsOfUse.singlePage,
  prepaidSupportHours: Number(this.termsOfUse.prepaidSupportHours.replace(',', '.')),
  spentSupportHours: Number(termsOfUse.spentSupportHours.replace(',', '.')),
  text: termsOfUse.text,
}) as TermsOfUse;

export default {
  createTermsOfUseVm,
  mapTermsOfUseToTermsOfUseVm,
  mapTermsOfUseVmToTermsOfUse,
};
